/* eslint-disable */

/**
 * 国际美居已接入多语言平台，不再使用此文件
 * 国际东芝页面继续使用
 */

// 中文
const zh_CN = {
    introduce: 'MSmartHome',
    banner: '让家无处不在!',
    download: '立即下载',
    cancel: '取消',
    confirm: '确定',
    remind: '你也可以在应用市场中搜索“MSmartHome”下载App。'
};

// 繁体中文
const zh_HK = {
    introduce: 'MSmartHome',
    banner: '讓家無處不在!',
    download: '立即下載',
    cancel: '取消',
    confirm: '確定',
    remind: '你也可以在App Store中搜索“MSmartHome”下載App。'
};

// 繁体中文-台湾
const zh_TW = {
    introduce: 'MSmartHome',
    banner: '讓家無處不在!',
    download: '立即下載',
    cancel: '取消',
    confirm: '確定',
    remind: '你也可以在應用市場中搜索\\「MSmartHome\\」下載App。'
};

// 英文
const en = {
    introduce: 'MSmartHome',
    banner: 'Home is beside you anytime',
    download: 'Download now ',
    cancel: 'Cancel',
    confirm: 'Confirm',
    remind: 'You can also download the App by searching "MSmartHome" in your App Store or Play Store.'
};

// 西班牙语
const es = {
    introduce: 'MSmartHome',
    banner: '¡Haga un hogar en todas partes!',
    download: 'Descargue ahora',
    cancel: 'Cancelar',
    confirm: 'Identificar',
    remind: 'También puede descargar la aplicación buscando "MSmartHome" en su Tienda de Aplicaciones o Tienda de Juegos.'
};

// 法语
const fr = {
    introduce: 'MSmartHome',
    banner: 'Votre maison est à vos côtés tout le temps !',
    download: 'Télécharger maintenant',
    cancel: 'Annuler',
    confirm: 'Confirmer',
    remind: "Vous pouvez également télécharger l'application en recherchant « MSmartHome » dans votre App Store ou Play Store."
};

// 荷兰语
const nl = {
    introduce: 'MSmartHome',
    banner: 'Thuis is altijd naast je',
    download: 'Download nu',
    cancel: 'Annuleren',
    confirm: 'OK',
    remind: 'U kunt de app ook downloaden door te zoeken op "MSmartHome" in uw App Store of Play Store.'
};

// 葡萄牙语
const pt = {
    introduce: 'MSmartHome',
    banner: 'Sua casa com você a qualquer momento',
    download: 'Baixar agora',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    remind: 'Você também pode baixar o aplicativo buscando "MSmartHome" na App Store ou Play Store.'
};

// 泰语
const th = {
    introduce: 'MSmartHome',
    banner: 'ให้บ้านอยู่ทุกที่ทุกแห่งหน',
    download: 'ดาวน์โหลดเดี๋ยวนี้',
    cancel: 'ยกเลิก',
    confirm: 'ตกลง',
    remind: 'คุณยังสามารถดาวน์โหลดแอปโดยค้นหา "MSmartHome" ใน App Store หรือ Play Store ของคุณ'
};

// 越南语
const vi = {
    introduce: 'MSmartHome',
    banner: 'Để nhà luôn bên bạn!',
    download: 'Tải ngay',
    cancel: 'Huỷ bỏ',
    confirm: 'Xác nhận',
    remind: 'Bạn có thể tải ứng dụng bằng cách tìm kiếm "MSmartHome" trong App Store hoặc Play Store.'
};

// 德语
const de = {
    introduce: 'MSmartHome',
    banner: 'Fühlen Sie sich immer zuhause!',
    download: 'Jetzt herunterladen',
    cancel: 'Abbrechen',
    confirm: 'Bestätigen',
    remind: 'Sie können auch in App Store oder Play Store nach "MSmartHome" suchen, um die App herunterzuladen.'
};

// 意大利语
const it = {
    introduce: 'MSmartHome',
    banner: 'La casa è sempre con te!',
    download: 'Scarica ora',
    cancel: 'Cancellare',
    confirm: 'Conferma',
    remind: 'Puoi anche scaricare l\'app cercando "MSmartHome" nell\'App Store o nel Play Store.'
};

// 日语
const ja = {
    introduce: 'MSmartHome',
    banner: 'いつでも家にいるように！',
    download: '今すぐダウンロード',
    cancel: 'キャンセル',
    confirm: 'OK',
    remind: 'AppストアまたはPlayストアで「MSmartHome」を検索してAppをダウンロードできます。'
};

// 韩语
const ko = {
    introduce: 'MSmartHome',
    banner: '유비쿼터스 홈!',
    download: '지금 다운로드하세요.',
    cancel: '취소',
    confirm: '확인',
    remind: "앱스토어나 게임 스토어에서 'MSmartHome'을 검색하여 앱을 다운로드할 수도 있습니다."
};

// 俄语
const ru = {
    introduce: 'MSmartHome',
    banner: 'Создайте дом где бы вы не были!',
    download: 'Загрузить сейчас',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    remind: 'Вы также можете загрузить приложение путём поиска «MSmartHome» в вашем магазине приложений или магазине Play.'
};

// 波兰语
const pl = {
    introduce: 'MSmartHome',
    banner: 'Dom jest zawsze obok Ciebie!',
    download: 'Pobierz teraz',
    cancel: 'Anuluj',
    confirm: 'Tak',
    remind: 'Można również pobrać aplikację wyszukując "MSmartHome" w App Store lub Play Store.'
};

// 丹麦语
const da = {
    introduce: 'MSmartHome',
    banner: 'Hjem er ved siden af dig når som helst',
    download: 'Download nu',
    cancel: 'aflyst',
    confirm: 'OK',
    remind: 'Du kan også downloade appen ved at søge på "MSmartHome" i din App Store eller Play Store.'
};

// 乌克兰语
const uk = {
    introduce: 'MSmartHome',
    banner: 'Нехай ваш дім буде усюди!',
    download: 'Завантажити зараз',
    cancel: 'Відмінити',
    confirm: 'Ок',
    remind: 'Ви також можете завантажити програму, виконавши пошук «MSmartHome» у вашому App Store або Play Store.'
};

// 土耳其语
const tr = {
    introduce: 'MSmartHome',
    banner: 'Eviniz her zaman yanınızda olsun',
    download: 'Şimdi indir',
    cancel: 'İptal',
    confirm: 'Onaylıyorum',
    remind: 'Uygulamayı App Store veya Play Store\'da "MSmartHome" aratarak da indirebilirsiniz.'
};

// 罗马尼亚语
const ro = {
    introduce: 'MSmartHome',
    banner: 'Acasă este lângă tine oricând',
    download: 'Descărcați acum',
    cancel: 'Anulare',
    confirm: 'OK',
    remind: 'De asemenea, dvs. puteți descărca aplicația căutând „MSmartHome” în App Store sau în Play Store.'
};

// 阿拉伯语
const ar = {
    introduce: 'MSmartHome',
    banner: 'المنزل بجانبك في أي وقت',
    download: 'تنزيل',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    remind: 'يمكنك البحث عن MSmartHome في سوق البرامج التطبيقية، لتنزيل البرنامج التطبيقي.'
};

// 捷克语
const cs = {
    introduce: 'MSmartHome',
    banner: 'Udělejte si domov všude!',
    download: 'Stáhnout teď',
    cancel: 'Zrušit',
    confirm: 'Potvrdit',
    remind: 'Aplikaci si můžete stáhnout také vyhledáním „MSmartHome“ v App Store nebo Play Store.'
};

// 印尼语
const id = {
    introduce: 'MSmartHome',
    banner: 'Agar rumah berada di mana pun!',
    download: 'Unduh sekarang',
    cancel: 'Batal',
    confirm: 'Benar',
    remind: 'Anda juga dapat unduh App dengan mencari "MSmartHome" di App Store atau Play Store Anda.'
};

// 希伯来语
const he = {
    introduce: 'MSmartHome',
    banner: 'שהבית יהיה בכל מקום!',
    download: 'הורד עכשיו',
    cancel: 'לְבַטֵל',
    confirm: 'בטוח',
    remind: 'אתה יכול גם להוריד את היישום על ידי חיפוש "\\MSmartHome"\\ ב-App Store או ב-Play Store שלך.'
};

// 匈牙利语
const hu = {
    introduce: 'MSmartHome',
    banner: 'Az otthon bármikor melletted van',
    download: 'Letöltés most',
    cancel: 'Törlés',
    confirm: 'Megerősítés',
    remind: 'Az App-ot letöltheti az App Store vagy a Play Store alkalmazásboltban az "MSmartHome" kereséssel is.'
};

// 格鲁吉亚语
const ka = {
    introduce: 'MSmartHome',
    banner: 'სახლი ნებისმიერ დროს თქვენს გვერდშია ',
    download: 'გადმოწერე ახლავე ',
    cancel: 'გაუქმება',
    confirm: 'დადასტურება',
    remind: 'თქვენ ასევე შეგიძლიათ ჩამოტვირთოთ აპლიკაცია თქვენს App Store-ში ან Play Store-ში „MSmartHome“-ის ძიებით.'
};

// 塞尔维亚语
const sr = {
    introduce: 'MSmartHome',
    banner: 'Да чувам кућу свуда!',
    download: 'Преузми сада',
    cancel: 'Откажи',
    confirm: 'У реду',
    remind: 'Такође можете преузети апликацију тако што ћете претражити „MSmartHome“ у Апп Сторе-у или Плаи Сторе-у.'
};

// 哈萨克语
const kk = {
    introduce: 'MSmartHome',
    banner: 'Үй кез келген уақытта жаныңызда',
    download: 'Қазір жүктеу',
    cancel: 'Болдырмау',
    confirm: 'Растау',
    remind: 'Сондай-ақ, App-ті MSmartHome-ды енгізу арқылы App Store немесе Play Store-дан жүктеуге болады.'
};

// 马来语
const ms = {
    introduce: 'MSmartHome',
    banner: 'Untuk rumah berada di mana-mana!',
    download: 'Muat turun sekarang',
    cancel: 'Batalkan',
    confirm: 'OK',
    remind: 'Az alkalmazást letöltheti az App Store-ból vagy a Play Store-ból az \\"MSmartHome\\" kereséssel is.'
};

// 希腊语
const el = {
    introduce: 'MSmartHome',
    banner: 'Η Home είναι δίπλα σας ανά πάσα στιγμή',
    download: 'Λήψη τώρα',
    cancel: 'Ακύρωση',
    confirm: 'Επιβεβαίωση',
    remind: 'Μπορείτε να κατεβάσετε επίσης την εφαρμογή αναζητώντας "MSmartHome" στο App Store ή στο Play Store.σας.'
};

// 马其顿语
const mk = {
    introduce: 'MSmartHome',
    banner: 'Домот е покрај вас во секое време!',
    download: 'Симни сега',
    cancel: 'Откажете',
    confirm: 'Потврди',
    remind: 'Апликацијата може да ја преземете и со пребарување на "MSmartHome" во вашата App Store или Play Store.'
};

// 瑞典语
const sv = {
    introduce: 'MSmartHome',
    banner: 'Hem är bredvid dig när som helst!',
    download: 'Hämta nu',
    cancel: 'Avbryt',
    confirm: 'Bekräfta',
    remind: 'Du kan också ladda ner appen genom att söka "MSmartHome" i din App Store eller Play Store.'
};

export default {
    en,
    es,
    fr,
    nl,
    pt,
    th,
    vi,
    de,
    it,
    ja,
    ko,
    ru,
    pl,
    da,
    uk,
    tr,
    ro,
    ar,
    cs,
    id,
    he,
    hu,
    ka,
    sr,
    kk,
    ms,
    el,
    mk,
    sv,
    'zh-HK': zh_HK,
    'zh-CN': zh_CN,
    'zh-TW': zh_TW
};
